import { Supplier } from '../../models/supplier';

export interface SupplierState {
  selectedSupplier?: Supplier;
  doneLoading: boolean;
}

export const featureName = 'supplier';
